export const lightTheme = {
    body: '#f5f5f5',
    text: '#363537',
    toggleBorder: '#cdcdcd',
    background: '#ffffff',
    bgHover:'#f5f5f5'
}
export const darkTheme = {
    body: '#282c35',
    text: '#FAFAFA',
    toggleBorder: '#ffffff96',
    background: '#212529',
    bgHover:'#131722',
}
